import { Modal } from "../../../../components";
import { SubscriptionModalContainer } from "../../styled";

import { useOutsideAlerter } from "../../../../hooks";
import { SubscriptionTypeBody } from "./SubscriptionModal";
import { BillTypeBody } from "./BillTypeBody";

export const SubscriptionModal = ({ subscription, closeModal }) => {
  const [ref] = useOutsideAlerter(closeModal);
  return (
    <Modal>
      <SubscriptionModalContainer ref={ref}>
        {getModalBody(subscription, closeModal)}
      </SubscriptionModalContainer>
    </Modal>
  );
};

const getModalBody = (subscription, closeModal) => {
  switch (subscription.serviceType) {
    case "BILL":
      return <BillTypeBody bill={subscription} closeModal={closeModal} />;
    case "SUBSCRIPTION":
      return (
        <SubscriptionTypeBody
          subscription={subscription}
          closeModal={closeModal}
        />
      );

    default:
      return null;
  }
};
